import { EntityList } from "@dash/entity-list";
import { useTheme } from "@emotion/react";
import { formatDistanceToNow } from "date-fns";
import { pl } from "date-fns/locale";

import { isSignalGroupUnread, SignalDocumentGroup } from "./groupSignals";
import { SignalAppChips, SignalLevelChip } from "./SignalChips";
import { SignalDocumentPrimaryCell } from "./SignalDocumentPrimaryCell";
import { signalHref } from "./signalHref";
import { topSignalLevel } from "./signalLevel";

const signalRowHoverBackground = "rgba(0, 0, 0, 0.03)";

type Props = {
  items: SignalDocumentGroup[];
  onRowNavigate: (href: string, group: SignalDocumentGroup) => void;
};

export const AllSignalsTable: React.FC<Props> = ({ items, onRowNavigate }) => {
  const theme = useTheme();

  return (
    <EntityList
      items={items}
      rowHoverBackground={signalRowHoverBackground}
      getKey={(group) => group.key}
      onRowClick={(group) => {
        const href = signalHref(group.signals[0]);
        if (href) onRowNavigate(href, group);
      }}
      columns={(group) => {
        const primarySignal = group.signals[0];
        const level = topSignalLevel(group.signals);
        const uniqueApps = [...new Set(group.signals.map((signal) => signal.app))];
        const isUnread = isSignalGroupUnread(group);

        return [
          {
            header: "",
            isPrimary: true,
            content: <SignalDocumentPrimaryCell group={group} />,
          },
          {
            header: "Aplikacja",
            content: (
              <div css={{ display: "flex", flexWrap: "wrap", gap: "0.25rem" }}>
                <SignalAppChips apps={uniqueApps} />
              </div>
            ),
          },
          {
            header: "Poziom",
            content: <SignalLevelChip level={level} />,
          },
          {
            header: "Data",
            content: (
              <span
                css={{
                  color: theme.colors.secondaryText,
                  fontSize: "0.875rem",
                  whiteSpace: "nowrap",
                  fontWeight: isUnread ? 700 : 400,
                }}
              >
                {formatDistanceToNow(primarySignal.createdAt, { addSuffix: true, locale: pl })}
              </span>
            ),
          },
        ];
      }}
    />
  );
};
